import { render, staticRenderFns } from "./VoucherModal.vue?vue&type=template&id=0b06be59&scoped=true"
import script from "./VoucherModal.vue?vue&type=script&lang=js"
export * from "./VoucherModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06be59",
  null
  
)

export default component.exports